import { i18n } from 'i18n/i18n'
import { Component, createRef, h, RefObject } from 'preact'

import { CalculatorDataObj } from 'models/calculator-foreign'

type CalculatorDataProps = CalculatorDataObj

interface CalculatorDataState {
  isActive: boolean
}

export default class CalculatorData extends Component<CalculatorDataProps, CalculatorDataState> {
  private dialogRefs: RefObject<HTMLDialogElement>[]
  private containerRefs: RefObject<HTMLSpanElement>[]

  public constructor(props) {
    super(props)
    this.state = {
      isActive: false,
    }

    this.dialogRefs = [createRef<HTMLDialogElement>(), createRef<HTMLDialogElement>()]
    this.containerRefs = [createRef<HTMLSpanElement>(), createRef<HTMLSpanElement>()]
  }

  public render() {
    return (
      <div className="form-exchange">
        <div className="form-exchange-foreign__flex form-exchange-foreign--mb-16">
          <p className="form-exchange-foreign__text">
            {i18n('calculatorForegin.exchangeRates')}: {this.getFormattedProp('average_rate')}
          </p>
          <button
            className="form-exchange-foreign__show"
            data-show-more
            type="button"
            onClick={this.toggleIsActive}
          >
            {i18n('calculatorForegin.details')}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="9"
              height="19"
              viewBox="0 0 9 19"
              fill="none"
              className={`form-exchange-foreign__show-arrow ${this.state.isActive ? 'active' : ''}`}
            >
              <path
                d="M9 7.77734L4.5 12.2773L5.36442e-07 7.77734L1.05469 6.72266L4.5 10.168L7.94531 6.72266L9 7.77734Z"
                fill="#68A519"
              />
            </svg>
          </button>
        </div>
        {this.state.isActive && (
          <div>
            <div className="form-exchange-foreign__flex form-exchange-foreign--mb-13">
              <p className="form-exchange-foreign__text form-exchange-foreign__text">
                <b>{i18n('calculatorForegin.amountYouSend')}</b>
              </p>
              <p className="form-exchange-foreign__text form-exchange-foreign__flex-none">
                <b>
                  {this.getFormattedProp('bought_amount')} {this.getFormattedProp('bought_currency')}
                </b>
              </p>
            </div>
            <div id="EUR">
              <div className="form-exchange-foreign__flex form-exchange-foreign--mb-13 form-exchange-foreign--ms-8">
                <p className="form-exchange-foreign__text form-exchange-foreign__text">
                  {i18n('calculatorForegin.exchangeRates')}
                </p>
                <p className="form-exchange-foreign__text form-exchange-foreign__flex-none">
                  x {this.getFormattedProp('average_rate')}
                </p>
              </div>
              <div className="form-exchange-foreign__flex form-exchange-foreign--mb-13 form-exchange-foreign--ms-8">
                <p className="form-exchange-foreign__text">{i18n('calculatorForegin.exchangeAmount')}</p>
                <p className="form-exchange-foreign__text form-exchange-foreign__flex-none">
                  = {this.getFormattedProp('exchange_amount')} {this.getFormattedProp('sold_currency')}
                </p>
              </div>
              <div className="form-exchange-foreign__flex form-exchange-foreign--mb-13 form-exchange-foreign--ms-8">
                <p className="form-exchange-foreign__text">
                  {i18n('calculatorForegin.commissionWT')}
                  <span
                    className="calculator-chart__fee-wrapper form-exchange-foreign__tooltip"
                    ref={this.containerRefs[0]}
                  >
                    <dialog
                      className="calculator-chart__fee-info form-exchange-foreign__tooltip-dialog"
                      data-dialog
                      hidden
                      ref={this.dialogRefs[0]}
                    >
                      <span className="calculator-chart__fee-info-text">
                        {i18n('calculatorForegin.commissionAmount')} {this.getFormattedProp('sold_currency')}
                      </span>
                      <span className="calculator-chart__fee-triangle form-exchange-foreign__tooltip-triangle" />
                    </dialog>
                    <img
                      src="/wp-content/themes/wt-theme/assets/images/how-it-works/question-mark.svg"
                      className="help-tip-svg black-to-gray"
                      alt="question-mark"
                      loading="lazy"
                      height="14"
                      width="14"
                      data-open-dialog
                      onMouseEnter={() => this.toggleDialog(0, true)}
                      onMouseOut={() => this.toggleDialog(0, false)}
                    />
                  </span>
                </p>
                <p className="form-exchange-foreign__text form-exchange-foreign__flex-none">
                  - {this.getFormattedProp('fee_amount')} {this.getFormattedProp('sold_currency')}
                </p>
              </div>
              <div className="form-exchange-foreign__flex form-exchange-foreign--mb-13 form-exchange-foreign--ms-8">
                <p className="form-exchange-foreign__text">
                  {i18n('calculatorForegin.foreignTransferFee')}
                  <span
                    className="calculator-chart__fee-wrapper form-exchange-foreign__tooltip"
                    ref={this.containerRefs[1]}
                  >
                    <dialog
                      className="calculator-chart__fee-info form-exchange-foreign__tooltip-dialog"
                      data-dialog
                      hidden
                      ref={this.dialogRefs[1]}
                    >
                      <span className="calculator-chart__fee-info-text">
                        {i18n('calculatorForegin.equivalentFee')} {this.getFormattedProp('fee_original')}
                      </span>
                      <span className="calculator-chart__fee-triangle form-exchange-foreign__tooltip-triangle" />
                    </dialog>
                    <img
                      src="/wp-content/themes/wt-theme/assets/images/how-it-works/question-mark.svg"
                      className="help-tip-svg black-to-gray"
                      alt="question-mark"
                      loading="lazy"
                      height="14"
                      width="14"
                      data-open-dialog
                      onMouseEnter={() => this.toggleDialog(1, true)}
                      onMouseOut={() => this.toggleDialog(1, false)}
                    />
                  </span>
                </p>
                <p className="form-exchange-foreign__text form-exchange-foreign__flex-none">
                  {parseFloat(this.getFormattedProp('fee_original').replace(',', '.')) === 0 ? '' : '-'}
                  {this.getFormattedProp('transfer_type_fee')}
                </p>
              </div>
            </div>
            <div className="form-exchange-foreign__flex form-exchange-foreign--mb-16">
              <p className="form-exchange-foreign__text form-exchange-foreign__text--space">
                <b>{i18n('calculatorForegin.amountRecipientReceive')}</b>
              </p>
              <p className="form-exchange-foreign__text  form-exchange-foreign__flex form-exchange-foreign__flex-none">
                <b>
                  {this.getFormattedProp('sold_amount')} {this.getFormattedProp('sold_currency')}
                </b>
              </p>
            </div>
          </div>
        )}
      </div>
    )
  }

  public toggleDialog = (index: number, show: boolean) => {
    const dialog = this.dialogRefs[index].current
    const container = this.containerRefs[index].current
    if (!dialog) return

    if (show) {
      if (typeof dialog.show === 'function') {
        dialog.show()
      }
      dialog.removeAttribute('hidden')
    } else {
      if (typeof dialog.close === 'function') {
        dialog.close()
      }
      dialog.setAttribute('hidden', 'true')
    }
    if (container && typeof dialog.show !== 'function') {
      container.style.position = show ? 'relative' : ''
      dialog.classList.toggle('tooltip', show)
    }
  }

  public toggleIsActive = (): void => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }))
  }

  public getFormattedProp(propName: string): string {
    const propValue = this.props[propName]
    if (!propValue) return ''
    return propValue.toString().replace(/\./g, ',')
  }
}
